var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M493.8,55.2L388.5,4.5c-12.3-5.9-26.8-3.4-36.4,6.2L150.3,194.8l-87.9-66.7c-8.2-6.3-19.7-5.7-27.2,1.2L7,154.9 c-9.3,8.4-9.3,23.1-0.1,31.5L83.2,256L6.9,325.6c-9.2,8.4-9.2,23.1,0.1,31.5l28.2,25.7c7.7,6.9,19.1,7.4,27.2,1.2l87.9-66.7 l201.8,184.1c9.5,9.6,24.1,12.1,36.3,6.2l105.4-50.7c11.1-5.3,18.1-16.5,18.1-28.8V84C512,71.7,504.9,60.5,493.8,55.2L493.8,55.2z  M384.1,372.3L230.9,256l153.2-116.3V372.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsc);
export default __webpack_public_path__ + "static/media/vsc.7b7bceeda4dd90253ef6fe47e6a52653.svg";
export { ForwardRef as ReactComponent };